// extracted by mini-css-extract-plugin
export var container = "_4w-0";
export var fallback = "_4w-5";
export var fallbackIcon = "_4w-6";
export var hidden = "_4w-2";
export var image = "_4w-3";
export var loaded = "_4w-4";
export var placeholder = "_4w-1";